import { Card, Divider, Grid, makeStyles } from "@material-ui/core";
import * as React from "react";
import { Form } from "react-final-form";

import { required } from "react-admin";
import { Toolbar } from "react-admin";
import { Button } from "react-admin";
import { Delete } from "@material-ui/icons";
import { SelectInput } from "react-admin";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { SectionTitle } from "../../../../src/Components/SectionTitle";
import { Separator } from "../../../../src/Components/Separator";

const useStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "end",
  },
  gridItem: {
    margin: "0px 10px",
  },
}));
export const RedisClearCache = props => {
  const classes = useStyles(props);
  const dataProvider = useAppDataProvider();
  const [keyList, setKeyList] = React.useState<any>();
  const _allCacheValue: string = "allCacheKeys";

  React.useEffect(() => {
    GetStatusList();
  }, []);

  const GetStatusList = async () => {
    dataProvider
      .getRedisKeys()
      .then(response => {
        setKeyList?.([]);
        if (response?.data?.length > 0) {
          let data = response.data;
          const keyListObject = data.map(x => {
            return <option key={x}>{x}</option>;
          });
          setKeyList?.(keyListObject);
        }
      })
      .catch(error => {
        setKeyList?.([]);
      });
  };

  const handleSubmit = values => {
    if (values.key == _allCacheValue) {
      dataProvider.clearAllCache().then(() => {
        window.location.reload();
      });
    } else {
      dataProvider.clearCacheWithKey(values?.key ?? "").then(() => {
        window.location.reload();
      });
    }
  };

  return (
    <>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, form, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Card style={{ padding: "15px" }}>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SectionTitle label="Clear Redis Cache" />
                    <Divider />
                    <Separator />
                  </Grid>
                  <Grid item xs={12} sm={12} md={5} lg={5}>
                    <SelectInput
                      label="Redis Cache Key"
                      source="key"
                      choices={keyList}
                      optionText="key"
                      optionValue="key"
                      fullWidth
                      variant="outlined"
                      validate={required()}
                    />
                  </Grid>
                </Grid>
                <Toolbar {...props} placeholder="" className={classes.toolbar}>
                  <Button
                    label={"Clear Cache"}
                    size="medium"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                  >
                    <Delete />
                  </Button>
                  )
                </Toolbar>
              </Card>
            </form>
          );
        }}
      />
    </>
  );
};

export default RedisClearCache;
